export default function SecurityAssurance() {
  const features = [
    "Vaulted & Insured in UAE – Independent audit trails",
    "Shariah-Certified – Regulated and approved",
    "Full Traceability – Every gram logged and tracked",
    "AES-256 Encryption, 99.9% Uptime – Built for enterprise reliability",
  ];

  return (
    <section className=" py-8 md:py-10 lg:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          
          {/* Left Image */}
          <div className="w-full max-w-[300px] sm:max-w-[350px] lg:max-w-[400px]">
            <img
              src="/b2b/shield.png"
              alt="Security Shield"
              className="w-full h-auto"
            />
          </div>

          {/* Right Content */}
          <div className="w-full lg:flex-1">
            <div className="space-y-5 md:space-y-6">
              
              {/* Heading */}
              <div className="space-y-2 md:space-y-3 text-center lg:text-left">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#192839] leading-tight">
                  Trust, Compliance & Security
                </h2>
                <p className="text-sm sm:text-base md:text-lg text-[#40566d]">
                  Industry-Grade Security & Shariah Compliance
                </p>
              </div>

              {/* Features */}
              <div className="space-y-3 md:space-y-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-start gap-2 md:gap-3">
                    <img
                      src="/b2b/check-circle.svg"
                      alt="check"
                      className="w-4 h-4 sm:w-5 sm:h-5 mt-0.5"
                    />
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl text-[#192839] leading-tight">
                      {feature}
                    </p>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
